import Page from "../../../../modules/Core/Components/Page";
import templateDefault from "../../../templates/default/pages/user/profile";

export default class Profile extends Page {
  title = "profile";
  template = templateDefault;

  fullAuth = true;

  onAuth(data) {
    const { auth } = data;
    if (!auth.isAuthenticated()) {
      this.redirectTo("/signin");
    }
  }

  onLoad(data) {
    super.onLoad(data);
    this.getApp().updateWindowTitle(
      `${this.ucfirst("profile-title")} | ${this.ucfirst("window-title")}`
    );
  }
}
